import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { showWithComma } from '../../global/globalFunctions';

@Component({
  selector: 'app-new-overweight-load',
  templateUrl: './new-overweight-load.component.html',
  styleUrls: ['./new-overweight-load.component.css']
})
export class NewOverweightLoadComponent implements OnInit {

  tabActive: number = 0;

  // Gráfica de distribución de pacientes
  public barChartOptions: ChartOptions = {
    responsive: true
  };
  public barChartLabels: Label[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartData: ChartDataSets[] = [];

  // Gráfica de carga económica
  public barChartOptions2: ChartOptions = {
    responsive: true
  };
  public barChartLabels2: Label[] = [];
  public barChartType2: ChartType = 'bar';
  public barChartLegend2 = true;
  public barChartData2: ChartDataSets[] = [];

  constructor() {}

  ngOnInit() {
    this.loadChartDataFromLocalStorage();
  }

  loadChartDataFromLocalStorage() {
    const storedData = localStorage.getItem('valor_por_defecto');

    if (!storedData) {
      console.warn('No se encontraron datos en localStorage con la clave "valor_por_defecto"');
      return;
    }

    try {
      const response = JSON.parse(storedData);

      const enfermedades: string[] = [];
      const pacientes: number[] = [];
      const costos: number[] = [];

      for (const enfermedad in response) {
        if (response.hasOwnProperty(enfermedad)) {
          const totalPacientes = response[enfermedad].Total_pacientes || 0;
          const totalCostosData = response[enfermedad].Total_costos || 0;

          enfermedades.push(enfermedad);
          pacientes.push(totalPacientes);
          costos.push(totalCostosData);
        }
      }

      // Etiquetas para gráfica de pacientes
      this.barChartLabels = enfermedades.map((enfermedad, index) => {
        return `${enfermedad} - ${showWithComma(pacientes[index])}`;
      });

      this.barChartData = [{
        data: pacientes,
        label: 'Total Pacientes',
        backgroundColor: '#39B0C1',
        borderColor: '#39B0C1',
        hoverBackgroundColor: '#1790A0',
        pointHoverBackgroundColor: '#FFFFFF'
      }];

      // Etiquetas para gráfica de costos
      this.barChartLabels2 = enfermedades.map((enfermedad, index) => {
        const costo = costos[index];
        return `${enfermedad} - ${showWithComma(costo)}$`;
      });

      this.barChartData2 = [{
        data: costos,
        label: 'Total Costos',
        backgroundColor: '#F6B70D',
        borderColor: '#F6B70D',
        hoverBackgroundColor: '#F49C11',
        pointHoverBackgroundColor: '#FFFFFF'
      }];
    } catch (error) {
      console.error('Error al parsear los datos del localStorage', error);
    }
  }
}
